import { resolveCandidateSegments } from "../../models/market-segment"

/**
 * Teal insert-face backgrounds: the value declared in uv-inserts-config.liquid
 * (`var(--color-teal)`) and its resolved hex from theme.css.
 */
const TEAL_BACKGROUNDS = new Set(["var(--color-teal)", "#2a4e50"])

/** Placeholder colour for MENS inserts on teal faces: white at 70% opacity. */
export const MENS_TEAL_PLACEHOLDER_COLOR = "rgba(255, 255, 255, 0.7)"

/**
 * Placeholder colour for editable text boxes on a UV insert face.
 *
 * MENS-eligible configs render teal faces with white copy, where the browser's
 * default grey placeholder is illegible — those get white at 70% opacity.
 * Everything else returns undefined and keeps the browser default.
 *
 * Pure function — no window access.
 */
export function getUvInsertTextPlaceholderColor(options: {
  /** The config's `marketSegment` (empty → WOMENS, per the shared rule). */
  marketSegment: string[]
  /** The face's `backgroundColor` as declared in uv-inserts-config.liquid. */
  faceBackgroundColor?: string
}): string | undefined {
  const { marketSegment, faceBackgroundColor } = options
  if (!resolveCandidateSegments(marketSegment).includes("MENS")) {
    return undefined
  }
  const background = faceBackgroundColor?.replace(/\s+/g, "").toLowerCase() ?? ""
  return TEAL_BACKGROUNDS.has(background) ? MENS_TEAL_PLACEHOLDER_COLOR : undefined
}
